/**@jsx jsx */
import { useEffect } from 'react'
import { css, jsx } from '@emotion/core'
import { TextField, Button } from '@material-ui/core'
import { useState } from 'react'
import Alert from './Alert';

const ContactUs = () => {

    const [fullName, setFullName] = useState('full name')
    const [companyName, setCompanyName] = useState('company name')
    const [job, setJob] = useState('job')
    const [phone, setPhone] = useState('phone')
    const [email, setEmail] = useState('email')
    const [notes, setNotes] = useState('')
    const [errorAlertOpen, setErrorAlertOpen] = useState(false)
    const [successAlertOpen, setSuccessAlertOpen] = useState(false)
    const [disableSend, setDisableSend] = useState(true)

    const mailFormat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const handleSendEmail = () => {
        const templateId = 'template_flgawdh';
        sendFeedback(templateId, {full_name: fullName, company_name: companyName, job: job, phone: phone, email: email, notes: notes})
    }

    const sendFeedback = (templateId, variables) => {
        window.emailjs.send(
          'sentoryglobal@gmail.com', templateId,
          variables
          ).then(res => {
            setSuccessAlertOpen(true);
          })
          .catch(err => { 
              setErrorAlertOpen(true);
            })
      }

    useEffect(() => {

        if ((phone !== '' && phone !== 0 && phone !== 'phone') &&
         (fullName !== '' && fullName !== 'full name') && 
         (email !== '' && email !== 'email') &&
         (email.match(mailFormat))) {
            setDisableSend(false)
        }
        else {
            setDisableSend(true)
        }
    }, [phone, fullName, email, mailFormat])

    useEffect(() => {
        if (errorAlertOpen) {
            setErrorAlertOpen(true)
        }
        else {
            setErrorAlertOpen(false)
        }
        if(successAlertOpen) {
            setSuccessAlertOpen(true)
        }
        else {
            setSuccessAlertOpen(false)
        }
    }, [errorAlertOpen, successAlertOpen])

    const contactPage = css`
    direction: rtl;
    font-family: Segoe UI;
    display: flex;
    justify-content: center;
    `;

    const imgStyle = css`
    position: relative;
    width: 100%;
    height: fit-content;
    @media only screen and (max-width: 1080px) {
        display: none;
    }
    `;

    const cardStyle = css`
    position: absolute;
    background: white;
    border-radius: 15px;
    min-width: 65%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-bottom: 10px;
    box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
    @media only screen and (max-width: 1080px) {
        box-shadow: 0 0 black;
    }
    `;

    const contactHeader = css`
    display: flex;
    justify-content: center;
    margin-bottom: 1%;
    font-size: 155%;
    `;

    const subContactHeader = css`
    display: flex;
    justify-content: center;
    margin-bottom: 1%;
    font-size: 100%;
    `;

    const contactUsContainer = css`
    display: flex;
    justify-content: space-around;
    `;
    const textFieldsContainer = css`
    display: flex;
    flex-direction: row;
    width: 40%;
    direction: rtl;
    @media only screen and (max-width: 1080px) {
        flex-direction: column;
        width: 80%;
    }
    `;

    const textFieldsInnerContainer = css`
    display: flex;
    flex-direction: column;
    margin-right: 2%;
    `;

    const textFieldsInnerContainerRight = css`
    display: flex;
    flex-direction: column;
    @media only screen and (max-width: 1080px) {
        margin-right: 2%;
    }
    `;

    const textFieldStyle = css`
    margin-bottom: 5%;
    .MuiFormLabel-root {
        width: fit-content;
        font-family: Segoe UI;
        position: absolute;
        right: 15%;
        padding-left: 5px;
        padding-right: 5px;
    }
    .MuiFormLabel-root.Mui-focused {
        color: #55baff;
    }
    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: #55baff;
    }
    .MuiInputBase-input {
        font-family: Segoe UI;
    }
    .PrivateNotchedOutline-legendLabelled-7 > span {
        display: none;
    }
    .MuiInputLabel-shrink {
        transform-origin: top right;
        background: white;
    }
    .MuiOutlinedInput-notchedOutline {
        border-color: #0000004a;
    }
    `;

    const phoneContainer = css`
    margin-bottom: 5%;
    .MuiFormLabel-root {
        width: fit-content;
        font-family: Segoe UI;
        position: absolute;
        right: 15%;
        padding-left: 5px;
        padding-right: 5px;
    }
    .PrivateNotchedOutline-legendLabelled-7 > span {
        display: none;
    }
    .MuiInputLabel-shrink {
        transform-origin: top right;
        background: white;
    }
    .MuiInputBase-input {
        direction: ltr;
        font-family: Segoe UI;
    }
    .MuiOutlinedInput-notchedOutline {
        border-color: #0000004a;
    }
    .MuiFormLabel-root.Mui-focused {
        color: #55baff;
    }
    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: #55baff;
    }
    `;

    const mailCommentsContainer = css`
    width: 40%;
    align-self: center;
    @media only screen and (max-width: 1080px) {
        width: 74%;
        margin-left: 4%;
    }
    `;

    const mailContainer = css`
    margin-bottom: 3%;
    @media only screen and (max-width: 1080px) {
        margin-bottom: 5%;
    }
    .MuiFormLabel-root {
        width: fit-content;
        font-family: Segoe UI;
        position: absolute;
        right: 15%;
        padding-left: 5px;
        padding-right: 5px;
    }
    .MuiFormControl-root {
        width: 100%;
    }
    .PrivateNotchedOutline-legendLabelled-7 > span {
        display: none;
    }
    .MuiInputLabel-shrink {
        transform-origin: top right;
        background: white;
    }
    .MuiInputBase-input {
        direction: ltr;
        font-family: Segoe UI;
    }
    .MuiOutlinedInput-notchedOutline {
        border-color: #0000004a;
    }
    .MuiFormLabel-root.Mui-focused {
        color: #55baff;
    }
    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: #55baff;
    }
    `;

    const commentsStyle = css`
    width: 100%;
    `;

    const buttonContainer = css`
    display: flex;
    justify-content: center;
    margin-top: 1%;
    margin-bottom: 5%;
    .MuiButton-outlined {
        border: 2px solid #4d86d7;
    }
    .MuiButton-root {
        font-family: inherit;
        width: 25%;
        background-color: #4d86d7;
        color: white;
        font-weight: bold;
    :hover {
        transition: 0.2s;
        color: black;
        }
    }
    `;

    const buttonStyle = css`
    margin-top: 0.7em;
    border-color: #2f47bd;
    border-width: 2.3px;
    color: #2f47bd;
    height: 3em;
    `;

    return (
        <div css={contactPage}>
            <img css={imgStyle} alt={''} src={require('../pictures/bg.jpg')} />
            <div css={cardStyle}>
                <h1 css={contactHeader}>צור קשר</h1>
                <div css={subContactHeader}>השאר פרטייך ונחזור אלייך תוך 24 שעות</div>
                <div css={contactUsContainer}>
                    <div css={textFieldsContainer}>
                        <div css={textFieldsInnerContainerRight}>
                            <div css={textFieldStyle}>
                                <TextField
                                    error={fullName === ''}
                                    label="שם מלא"
                                    variant="outlined"
                                    onChange={(event) => setFullName(event.target.value)}
                                />
                            </div>
                            <div css={textFieldStyle}>
                                <TextField
                                    label="חברה"
                                    variant="outlined"
                                    onChange={(event) => setCompanyName(event.target.value)}
                                />
                            </div>
                        </div>
                        <div css={textFieldsInnerContainer}>
                            <div css={textFieldStyle}>
                                <TextField
                                    label="תפקיד"
                                    variant="outlined"
                                    onChange={(event) => setJob(event.target.value)}
                                />
                            </div>
                            <div css={phoneContainer}>
                                <TextField
                                    error={phone === '' || phone === 0}
                                    label="טלפון"
                                    variant="outlined"
                                    onChange={(event) => setPhone(Number(event.target.value))}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div css={mailCommentsContainer}>
                    <div css={mailContainer}>
                        <TextField
                            error={email === ''}
                            label="מייל"
                            variant="outlined"
                            onChange={(event) => setEmail(event.target.value)}
                        />
                    </div>
                    <div css={textFieldStyle}>
                        <TextField
                            value={notes}
                            label="הערות"
                            multiline
                            rows={4}
                            variant="outlined"
                            onChange={(event) => setNotes(event.target.value)}
                            css={commentsStyle}
                        />
                    </div>
                </div>
                <div css={buttonContainer}>
                    <Button
                        onClick={handleSendEmail}
                        css={buttonStyle}
                        variant="outlined"
                        disabled={disableSend}
                    >
                        שלח
                        </Button>
                </div>
            </div>
            {successAlertOpen && <Alert alertType={'success'} setIsAlertOpen={setSuccessAlertOpen} />}
            {errorAlertOpen && <Alert alertType={'error'} setIsAlertOpen={setErrorAlertOpen} />}
        </div>
    );
}

export default ContactUs;
